import Axios from "./axios";

const resource = "about-us-sliders";

export default {
  get() {
		return Axios.get(`${resource}`);
	}
}